import React, { Component } from 'react';
import { Key } from 'react-feather';
import { addPasskey, errorMessage, passkeysSupported, verifyWithPasskey } from '../../util/adminStepUp';

// Shown on /impersonate until this browser holds a valid 24-hour passkey
// step-up. With no passkey yet, it enrols one (current password required),
// then verifies with it straight away.
class AdminStepUpPanel extends Component {
    state = { busy: false, error: null, label: '', password: '' };

    verify = async () => {
        this.setState({ busy: true, error: null });
        try {
            await verifyWithPasskey();
            this.props.onVerified();
        } catch (err) {
            this.setState({ busy: false, error: errorMessage(err, 'Could not verify your passkey.') });
        }
    };

    enrolThenVerify = async (e) => {
        e.preventDefault();
        this.setState({ busy: true, error: null });
        try {
            await addPasskey({ label: this.state.label.trim() || 'Passkey', currentPassword: this.state.password });
            this.setState({ password: '' });
            await verifyWithPasskey();
            this.props.onVerified();
        } catch (err) {
            this.setState({ busy: false, error: errorMessage(err, 'Could not add the passkey.') });
        }
    };

    render() {
        const { hasPasskeys } = this.props;
        const { busy, error, label, password } = this.state;

        if (!passkeysSupported()) {
            return (
                <div className="section admin-step-up">
                    <h2><Key /> Passkey required</h2>
                    <p>This browser does not support passkeys. Open Synaptiq in a current desktop browser to browse users.</p>
                </div>
            );
        }

        return (
            <div className="section admin-step-up">
                <h2><Key /> Verify it's you</h2>
                {hasPasskeys ? (
                    <>
                        <p>Browsing and impersonating users needs a passkey check. It stays valid on this browser for 24 hours.</p>
                        <button className="button button--secondary" disabled={busy} onClick={this.verify}>
                            {busy ? 'Waiting for your passkey…' : 'Verify with passkey'}
                        </button>
                    </>
                ) : (
                    <form onSubmit={this.enrolThenVerify}>
                        <p>Set up a passkey to browse and impersonate users. You'll confirm it with your device's fingerprint, face or PIN, and the check stays valid on this browser for 24 hours.</p>
                        <label htmlFor="admin-passkey-label">Passkey name</label>
                        <input id="admin-passkey-label" className="input" type="text" maxLength={100} placeholder="e.g. Work laptop" value={label} onChange={(e) => this.setState({ label: e.target.value })} />
                        <label htmlFor="admin-passkey-password">Current password</label>
                        <input id="admin-passkey-password" className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => this.setState({ password: e.target.value })} required />
                        <button className="button button--secondary" type="submit" disabled={busy || !password}>
                            {busy ? 'Waiting for your passkey…' : 'Set up passkey'}
                        </button>
                    </form>
                )}
                {error && <p className="text--error m-t-1">{error}</p>}
            </div>
        );
    }
}

export default AdminStepUpPanel;
